$('#testimonial').owlCarousel({
			 loop:true,
			 margin:30,
			 dots:false,
			 nav:true,
			 responsive:{
			     0:{
			         items:1.3, nav:false,dots:true,
			     },
			     600:{
			         items:3
			     },
			     1000:{
			         items:4
			     }
			 }
			})
$('#curvy').owlCarousel({
			  loop:true,
			  margin:30,
			  nav:true,
			dots:false,
			  responsive:{
			      0:{
			          items:1.3,nav:false,dots:true,
			      },
			      600:{
			          items:3
			      },
			      1000:{
			          items:4
			      }
			  }
			})
$('#curvy-design').owlCarousel({
			  loop:true,
			  margin:30,
			  nav:true,
			dots:false,
			  responsive:{
			      0:{
			          items:1.3,nav:false,dots:true,
			      },
			      600:{
			          items:3
			      },
			      1000:{
			          items:4
			      }
			  }
			})
 document.addEventListener('DOMContentLoaded', function() {
    const newsletterForm = document.getElementById('NewsletterForm');
    const successMessage = document.getElementById('Newsletter-success--{{ section.id }}');
    const errorMessage = document.getElementById('Newsletter-error--{{ section.id }}');

    newsletterForm.addEventListener('submit', function(e) {
      e.preventDefault(); // Prevent the form from submitting normally

      const formData = new FormData(newsletterForm);

      // Show a loading indicator if needed
      // You can add a loading message or spinner here

      fetch(newsletterForm.action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
      })
      .then(response => response.json())
      .then(data => {
        // Check if submission was successful
        if (data.status === 'success') {
          // Hide error messages, if any
          if (errorMessage) {
            errorMessage.style.display = 'none';
          }

          // Show success message
          successMessage.style.display = 'block';
        } else {
          // Show error message
          if (data.errors && data.errors.email) {
            errorMessage.textContent = data.errors.email[0];
            errorMessage.style.display = 'block';
          }
        }
      })
      .catch(error => {
        console.error('Error submitting the form:', error);
      });
    });
  });
$(document).ready(function() {
    $("#search").click(function() {
        $(".search-bar-mob").css("display", "block");

    });
    $("#search-mob").click(function() {
        $(".search-bar-mob").css("display", "block");

    });
    $("a.crs-btn").click(function() {
        $(".search-bar-mob").css("display", "none");

    });
});
 // if (window.location.pathname === '/collections') {
 //    window.location.href = '/';
 //  }